import {ConsumeApi} from '../request/Consume/consume_api'
import store from '../store'
import {CommonApi} from '../request/common_api'

function applyTypeList () {
  // 应用类型列表
  if (store.state.consume.applyTypeList.length) {
    return
  }
  ConsumeApi.consumeDropDownList('001', {})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('consume/setApplyTypeList', res.BizBodyMsg.codeList)
      }
    })
}

function welfareList () {
  // 福利列表
  if (store.state.consume.welfareList.length) {
    return
  }
  ConsumeApi.consumeDropDownList('002', {})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('consume/setWelfareList', res.BizBodyMsg.codeList)
      }
    })
}

function workTimeList (data = {}) {
  // 工作时段列表
  // if (store.state.consume.workTimeList.length) {
  //   return
  // }
  ConsumeApi.consumeDropDownList('003', data)
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('consume/setWorkTimeList', res.BizBodyMsg.codeList)
      }
      // console.log(res.BizBodyMsg, store.state.consume.workTimeList)
    })
}

function bfuseageSorts () {
  // 优惠开放时限下拉框
  if (store.state.consume.bfuseageSorts.length) {
    return
  }
  CommonApi.getTableList('BFUSEAGE').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setBfuseageSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function posNoList (merchid = '', termType = '') {
  // 终端号列表
  ConsumeApi.consumeDropDownList('004', {merchid: merchid, termType: termType})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('consume/setPosNoLIst', res.BizBodyMsg.codeList)
      }
    })
}

async function rechargeTypeSorts () {
  // 充值类型列表
  if (store.state.consume.rechargeTypeSorts.length) {
    return
  }
  await ConsumeApi.consumeDropDownList('005', {type: '2'})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('consume/setRechargeTypeSorts', res.BizBodyMsg.codeList)
      }
    })
}

async function rechargeTypeLists () {
  // 充值类型列表
  if (store.state.consume.rechargeTypeLists.length) {
    return
  }
  await ConsumeApi.consumeDropDownList('005', {type: '0'})
    .then(res => {
      if (res.retCode === '0000') {
        store.commit('consume/setRechargeTypeLists', res.BizBodyMsg.codeList)
      }
    })
}

function machineDealTypeSorts () {
  // 终端交易类型列表
  if (store.state.consume.machineDealTypeSorts.length) {
    return
  }
  ConsumeApi.consumeDropDownList('007', {}).then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setMachineDealTypeSorts', res.BizBodyMsg.codeList)
    }
  })
}

function incomeDealTypeSorts () {
  // 收入明细表交易类型
  if (store.state.consume.incomeDealTypeSorts.length) {
    return
  }
  ConsumeApi.consumeDropDownList('005', {type: '10'}).then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setIncomeDealTypeSorts', res.BizBodyMsg.codeList)
    }
  })
}

function orderTypeSorts () {
  // 支付类型下拉框
  if (store.state.consume.orderTypeSorts.length) {
    return
  }
  CommonApi.getTableList('ORDERTYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setOrderTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function orderPayFlagSorts () {
  // 订单支付状态下拉框
  if (store.state.consume.orderPayFlagSorts.length) {
    return
  }
  CommonApi.getTableList('ORDERPAYFLAG').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setOrderPayFlagSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function feeTypeSorts () {
  // 费用类型下拉框
  if (store.state.consume.feeTypeSorts.length) {
    return
  }
  CommonApi.getTableList('FEETYPE').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setFeeTypeSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function feePayMethod () {
  // 费用支付方式
  if (store.state.consume.feePayMethod.length) {
    return
  }
  CommonApi.getTableList('FEEPAYMETHOD').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setFeePayMethod', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function clearFlagSorts () {
  // 销户结清状态
  if (store.state.consume.clearFlagSorts.length) {
    return
  }
  CommonApi.getTableList('CLEARFLAG').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setClearFlagSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function refMethodSorts () {
  // 销户结清状态
  if (store.state.consume.refMethodSorts.length) {
    return
  }
  CommonApi.getTableList('CLSREFMETHOD').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setRefMethodSorts', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function deviceAreaList (merchid = '') {
  // 设备区域下拉框
  ConsumeApi.consumeDropDownList('009', {merchid: merchid}).then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setDeviceAreaList', res.BizBodyMsg.codeList)
    }
  })
}

function deviceInstallSiteList (devareaid = '', merchid = '') {
  // 设备安装地点下拉框
  ConsumeApi.consumeDropDownList('010', {devareaid: devareaid, merchid: merchid}).then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setDeviceInstallSiteList', res.BizBodyMsg.codeList)
    }
  })
}

function deviceConsumeSiteList (devareaid = '', merchid = '') {
  // 设备消费地点下拉框
  ConsumeApi.consumeDropDownList('011', {devareaid: devareaid, merchid: merchid}).then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setDeviceConsumeSiteList', res.BizBodyMsg.codeList)
    }
  })
}

function saleChannelList() {
  // 销售渠道下拉框
  if (store.state.consume.saleChannelList.length) {
    return
  }
  CommonApi.getTableList('SALECHANNEL').then(res => {
    if (res.retCode === '0000') {
      store.commit('consume/setSaleChannelList', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

const getConsumeDropDownList = {applyTypeList, welfareList, workTimeList, posNoList, bfuseageSorts, rechargeTypeSorts, rechargeTypeLists, machineDealTypeSorts, orderTypeSorts, orderPayFlagSorts, feeTypeSorts, feePayMethod, clearFlagSorts, refMethodSorts, deviceAreaList, deviceInstallSiteList, deviceConsumeSiteList, incomeDealTypeSorts, saleChannelList}

export {getConsumeDropDownList}



// WEBPACK FOOTER //
// ./src/util/ConsumeDropDownList.js